/**
 * Survey: PROJECT - FINAL IMPACT
 * Question: Please specify which sale channel.
 * 
 * == final
 * sale_channels_name_t1
 * 
 * @param props 
 * @returns 
 */
export const typeOfNewSalesChannelsChartCalculation = (props: any) => {
    const data = props.finalSubmissions.reduce((
        acc: {name: string, weight: number}[],
        submission: any
    ) => {
        const answer = submission.sale_channels_name_t1;

        if (!answer) return acc;

        const answerIndex = acc.findIndex(el => el.name === answer);

        answerIndex !== -1 ? acc[answerIndex].weight++ : acc.push({name: answer, weight: 3});

        return acc;
    }, []);

    return {
        title: {
            text: 'Type of new sales channels',
            align: 'left'
        },
        tooltip: {
            headerFormat: '<span style="font-size: 16px"><b>{point.key}</b>' +
                '</span><br>'
        },
        series: [{
            type: 'wordcloud',
            data,
            name: 'Type'
        }],
    } as Highcharts.Options;
}